export default __webpack_public_path__ + "static/media/gmail.8d55216f.png";